import * as React from "react";
export const ViewMoreBtn = (props) => React.createElement("div", { className: "rj-ev-list__view-more-btn__wrap", "data-uat": "div-ev-list-view-more-btn-wrap" },
    React.createElement("div", { className: "rj-ev-list__view-more-btn", "data-uat": "div-ev-list-view-more-btn", onClick: props.onClick }, props.text));
//# sourceMappingURL=ViewMoreBtn.js.map